import type { Tag } from "@/shared/api/newsquawk-headlines";
import type { HeadlineTimestamp } from "@/widget-components/newsquawk-headlines/models/Headline";

/** checkbox options */
export const checkboxOptions = {
  appears_on_capital: false,
  appears_on_newsquawk: true,
  hidden: false,
  appears_on_us_equities: false,
  public_visibility: false,
  push_notify: false,
  scheduled: false,
};

export const checkableTags = [
  { id: 195272, label: "Important" },
  { id: -1, label: "Flash" },
  { id: 195607, label: "Research" },
  { id: 195434, label: "Highlighted" },
] as const;

type TagLabel = (typeof checkableTags)[number]["label"];

export const checkableTagIds = checkableTags.reduce((prev, curr) => {
  prev[curr.label] = curr.id;
  return prev;
}, {} as Record<TagLabel, number>);

/**
 * Form type for headline creation/editing.
 * Explicitly defined to avoid index signature issues with useFieldArray.
 */
export type HeadlineForm = {
  /** Tags managed by useFieldArray */
  tags: Tag[];
  existing_tags?: { [key: string]: number };
  tagCheckboxes?: Record<TagLabel, boolean>;
  section_id?: number;
  section?: string;
  // Text fields
  id?: number;
  subject?: string;
  content?: string;
  source?: string;
  published_at?: string | HeadlineTimestamp;
  linked_content?: string;
  reaction_details?: string;
  analysis_details?: string;
} & Partial<typeof checkboxOptions>;
